import type {ProgramApiModel} from '../../../api/program';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';

export const isProgramOffered = <P extends Partial<ProgramApiModel>>(
  program?: Nullable<P>,
) => {
  return isDefined(program?.offer_id);
};
